export const getBadgePropsByStatus = (status: string | number) => {
  const numStatus = Number(status);

  switch (numStatus) {
    case 0:
      return { label: '参加予定', colorScheme: 'yellow' };
    case 1:
      return { label: '参加', colorScheme: 'green' };
    case 2:
      return { label: '不参加', colorScheme: 'gray' };
    case 3:
      return { label: 'キャンセル', colorScheme: 'red' };
    default:
      return { label: '', colorScheme: '' };
  }
};